<template>
    <div class="full-width-editor" v-loading="loading">
        <div class="title-part">
            <el-text type="primary" @click="clickReturnBtn" tkey="返回"><font-awesome-icon icon="fa-solid fa-arrow-left" />&nbsp;{{i18n.tkey("lang_return")}}</el-text>
        </div>

        <div v-show="viewPart == 'agent' || viewPart == 'supplier'">

            <div class="type-btn-group operation-box" >
                <div>
                    <el-text type="primary">
                        <span tkey="我的代理">{{i18n.tkey("lang_myagent")}}</span>
                    </el-text>
                </div>

                <div>

                  <el-button type="primary" @click="clickGoBackstageBtn">
                    <span tkey="供應商">{{i18n.tkey("lang_title_backstage")}}</span>
                  </el-button>
                    <el-button type="primary" @click="clickInsertBtn" tkey="月結單">{{i18n.tkey("lang_month_bill")}}</el-button>
                </div>
            </div>

            <div v-if="viewPart == 'agent'">
                <MyAgentList :dataList="dataList" :pageObj="pageObj" @goPage="clickAgentPageBtn" @goShare="clickShareBtn" @save-complete="getAgentList" />
            </div>



        </div>
<!--      <agentProdutShare
          :shareobj="produtobj"
          @clickReturnBtn="goView('home')"
      />-->
      <div
          v-if="viewPart === 'agentshare'" style="text-align: center">
        <h2 type="primary">
          <span tkey="產品分享">{{i18n.tkey("lang_share")}}</span>
        </h2>
      </div>
      <Share3DUrl
          v-if="viewPart === 'agentshare'"
          :companycode="shopCompany.companycode"
          :url="shopUrl"
          :type="2"
      />
        <MonthBill :editObj="editObj" v-if="viewPart == 'monthBill'" />
        <InsertOrEditSupplierRecord :editObj="editObj" @save-complete="clickReturnBtn" v-if="viewPart == 'editSupplier'" />

    </div>
</template>

<script setup>

import {inject, ref, onBeforeMount, toRef, getCurrentInstance, computed} from "vue";
import MyAgentList from "@/components/shopopee/agent/myAgentList.vue";
import MonthBill from "@/components/shopopee/agent/monthBill.vue";
import InsertOrEditSupplierRecord from "@/components/shopopee/agent/insertOrEditSupplierRecord.vue";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import record3Api from "@/request/record3Api";
import {useUserinfo} from "@/stores/userinfo";
import myUtil from "@/util/util";
import agentProdutShare from "@/components/shopopee/agent/agentProdutShare.vue";
import Share3DUrl from "@/components/shopopee/share/share3DUrl.vue";

library.add(faArrowLeft)

const emits = defineEmits(["clickReturnBtn"])

const { proxy } = getCurrentInstance()
const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

const i18n = inject("i18n")
const shopCompany = ref({})
const loading = ref(false)

//顯示內容
const viewPart = ref("agent")

const dataList = ref([])
const pageNum = ref(1)
const pageSize = ref(10)
const pageObj = ref({})

const editObj = ref(null)
const userinfoRef = toRef(useUserinfo())

const produtobj = ref(null)


function clickGoBackstageBtn(){

  myUtil.confirmWarning(i18n.tkey("lang_confirm_go_backstage"), () => {
    const window2 = window.open("", "shopopeebanser")

    setTimeout(() => {
      console.log(`${proxy.$ShopopeeUrl}backstage/backstageEntrance?id=${userinfoRef.value.id}`)
      window2.location.href  = `${proxy.$ShopopeeUrl}backstage/backstageEntrance?id=${userinfoRef.value.id}`
    }, 1000)

  })
}
function clickReturnBtn(){
    if ( viewPart.value == "monthBill" || viewPart.value == "agentshare"){
        if (null == editObj.value){
                viewPart.value = "agent"
        }else{
                viewPart.value = "agent"
        }

        editObj.value = null
    }else{
        emits("clickReturnBtn")
    }

}

function goView(v){

}
function checkAgentStats(){

        getAgentList()
}

function getAgentList(){
    loading.value = true

    const request = record3Api.queryAgentRecord3ByKeyword
    const params = request.getParams()

    params.addinfo2 = userinfoRef.value.id
    params.pageNum = pageNum.value
    params.pageSize = pageSize.value

    request.send(params, (res) => {
        loading.value = false
        if (res.code == 200){
            dataList.value = res.detail.list
            pageObj.value = res.detail
        }else{
            myUtil.alertError(res.msg)
        }
    })

}


function clickAgentPageBtn(num){
    pageNum.value = num
    getAgentList()
}

function clickShareBtn(value){

  viewPart.value = "agentshare"
  produtobj.value = value
}
const shopUrl = computed(() => {
  let link = ""
  if (produtobj.value!=null){
    link = `${proxy.$ShopopeeUrl}productInfo?id=${produtobj.value.id}`
  }
  return link
})

function clickInsertBtn(){
    editObj.value = null

    if (viewPart.value == "agent") {
      viewPart.value = "monthBill"
    }
}

onBeforeMount(() => {
    shopCompany.value = getShopCompanyObj()

    checkAgentStats()
})

</script>

<style scoped>
    .full-width-editor {
        width: 100%;
        position: relative;
        text-align: left;
    }

    .title-part {
        position: relative;
    }

    .type-btn-group {
        padding-top: 16px;
        padding-bottom: 16px;
    }

    .operation-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

</style>